import React, { useState, useEffect } from "react";
import $ from 'jquery';
import 'jquery-ui/themes/base/all.css';
import 'jquery-ui/ui/widgets/datepicker';
import Select from "react-select";

import Sidebar from "../../component/Sidebar";
import Topbar from "../../component/Topbar";
import { FiPlus, FiTrash2, FiFileText, FiUser, FiPackage, FiDollarSign, FiSettings, FiTag, FiCheckCircle, FiClock, FiSave, FiEdit3, FiZap } from "react-icons/fi";
import { FaInfoCircle } from "react-icons/fa";

import { baseurl } from "../../baseurl";
import axios from "axios";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

/* ─────────────────────────────── STYLES ─────────────────────────────── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;600;700;800&family=DM+Sans:ital,wght@0,300;0,400;0,500;0,600;1,400&display=swap');

:root {
  --t: #0a5556;
  --t2: #0c7070;
  --t3: #14b8a6;
  --t4: #5eead4;
  --gold: #FFD166;
  --bg: #edf7f7;
  --surface: rgba(255,255,255,0.93);
  --border: rgba(10,85,86,0.12);
  --danger: #ef4444;
  --success: #10b981;
  --warn: #f59e0b;
  --text: #07282a;
  --muted: #5a8080;
  --r: 18px;
  --r-sm: 10px;
  --sh: 0 4px 24px rgba(10,85,86,0.09), 0 1px 4px rgba(10,85,86,0.06);
}

@keyframes ei-up    { from{opacity:0;transform:translateY(22px)} to{opacity:1;transform:translateY(0)} }
@keyframes ei-in    { from{opacity:0} to{opacity:1} }
@keyframes ei-float { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-14px)} }
@keyframes ei-float2{ 0%,100%{transform:translateY(0)} 50%{transform:translateY(10px)} }
@keyframes ei-badge { 0%{transform:scale(1)} 50%{transform:scale(1.05)} 100%{transform:scale(1)} }

.ei-page { font-family:'DM Sans',sans-serif; background:var(--bg); min-height:100vh; position:relative; overflow-x:hidden; }
.ei-blob { position:fixed; border-radius:50%; pointer-events:none; z-index:0; }
.ei-blob-1 { width:460px;height:460px;top:-140px;right:-100px; background:radial-gradient(circle at 40% 40%,rgba(10,85,86,0.11),transparent 68%); animation:ei-float 11s ease-in-out infinite; }
.ei-blob-2 { width:340px;height:340px;bottom:60px;left:-80px; background:radial-gradient(circle at 60% 60%,rgba(20,184,166,0.10),transparent 68%); animation:ei-float2 14s ease-in-out infinite; }
.ei-blob-3 { width:200px;height:200px;top:50%;right:5%; background:radial-gradient(circle,rgba(255,209,102,0.08),transparent 70%); animation:ei-float 9s ease-in-out infinite 2s; }
.ei-grid  { position:fixed;inset:0;pointer-events:none;z-index:0; background-image:linear-gradient(rgba(10,85,86,0.025) 1px,transparent 1px),linear-gradient(90deg,rgba(10,85,86,0.025) 1px,transparent 1px);background-size:56px 56px; }

.ei-wrap { position:relative;z-index:1; padding:24px 24px 72px; animation:ei-in 0.4s ease; }

/* header */
.ei-hd { display:flex;align-items:center;justify-content:space-between;margin-bottom:26px; animation:ei-up 0.5s ease; }
.ei-hd-left { display:flex;align-items:center;gap:15px; }
.ei-hd-icon { width:50px;height:50px;border-radius:16px;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:22px;color:#fff; background:linear-gradient(135deg,var(--t),var(--t3)); box-shadow:0 8px 24px rgba(10,85,86,0.32); }
.ei-title { font-family:'Sora',sans-serif;font-size:23px;font-weight:800;color:var(--text);letter-spacing:-.04em;margin:0 0 2px;line-height:1; }
.ei-sub   { font-size:12.5px;color:var(--muted);margin:0; }
.ei-badge { display:inline-flex;align-items:center;gap:7px;padding:7px 16px;border-radius:50px;font-family:'Sora',sans-serif;font-size:11px;font-weight:700;color:#7a4f00;letter-spacing:.05em;text-transform:uppercase; background:rgba(255,209,102,0.18);border:1.5px solid rgba(255,209,102,0.45);animation:ei-badge 3s ease infinite 1s; }

/* section */
.ei-sec { display:flex;align-items:center;gap:10px;margin-bottom:13px;margin-top:4px; }
.ei-sec-dot { width:32px;height:32px;border-radius:10px;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:14px;color:#fff; background:linear-gradient(135deg,var(--t),var(--t3)); box-shadow:0 4px 12px rgba(10,85,86,0.26); }
.ei-sec-lbl { font-family:'Sora',sans-serif;font-size:13.5px;font-weight:700;color:var(--t);letter-spacing:.01em; }

/* card */
.ei-card { background:var(--surface);backdrop-filter:blur(24px);border:1px solid rgba(255,255,255,0.9);border-radius:var(--r);box-shadow:var(--sh);overflow:hidden;position:relative;margin-bottom:20px; }
.ei-card::before { content:'';position:absolute;top:0;left:0;right:0;height:3px;background:linear-gradient(90deg,var(--t) 0%,var(--t3) 55%,var(--gold) 100%); }
.ei-cb { padding:22px 24px; }
.ei-cf { padding:14px 24px;background:rgba(10,85,86,0.025);border-top:1px solid var(--border); }

/* form */
.ei-label { display:block;font-size:11px;font-weight:700;color:var(--t);letter-spacing:.065em;text-transform:uppercase;margin-bottom:6px;font-family:'Sora',sans-serif; }
.ei-hint  { font-size:10.5px;color:var(--muted);margin-top:4px;font-style:italic; }
.ei-input { width:100%;padding:9.5px 13px;background:rgba(10,85,86,0.035);border:1.5px solid rgba(10,85,86,0.13);border-radius:var(--r-sm);font-size:13px;color:var(--text);font-family:'DM Sans',sans-serif;outline:none;transition:border-color .2s,box-shadow .2s,background .2s;box-sizing:border-box; }
.ei-input:focus { border-color:var(--t);background:#fff;box-shadow:0 0 0 3px rgba(10,85,86,0.10); }
.ei-input::placeholder { color:#9abcbc; }
.ei-input:disabled { opacity:.5;cursor:not-allowed; }
.ei-input[readonly] { background:rgba(10,85,86,0.03);cursor:default; }
.ei-input-sm { padding:7px 11px;font-size:12.5px; }
.ei-select { width:100%;padding:9.5px 13px;background:rgba(10,85,86,0.035);border:1.5px solid rgba(10,85,86,0.13);border-radius:var(--r-sm);font-size:13px;color:var(--text);font-family:'DM Sans',sans-serif;outline:none;cursor:pointer;transition:border-color .2s,box-shadow .2s;box-sizing:border-box; }
.ei-select:focus { border-color:var(--t);box-shadow:0 0 0 3px rgba(10,85,86,0.10);background:#fff; }
.ei-select-sm { padding:7px 11px;font-size:12.5px; }
.ei-ta { width:100%;padding:9.5px 13px;background:rgba(10,85,86,0.035);border:1.5px solid rgba(10,85,86,0.13);border-radius:var(--r-sm);font-size:13px;color:var(--text);font-family:'DM Sans',sans-serif;outline:none;resize:vertical;transition:border-color .2s,box-shadow .2s;box-sizing:border-box; }
.ei-ta:focus { border-color:var(--t);background:#fff;box-shadow:0 0 0 3px rgba(10,85,86,0.10); }
.ei-field { margin-bottom:14px; }

/* toggle */
.ei-toggle { display:flex;border-radius:var(--r-sm);overflow:hidden;border:1.5px solid rgba(10,85,86,0.15);background:rgba(10,85,86,0.03); }
.ei-tbtn { flex:1;padding:8.5px 12px;border:none;background:transparent;font-size:12.5px;font-weight:600;font-family:'DM Sans',sans-serif;color:var(--muted);cursor:pointer;transition:all .2s;display:flex;align-items:center;justify-content:center;gap:5px;white-space:nowrap; }
.ei-tbtn:not(:last-child) { border-right:1.5px solid rgba(10,85,86,0.13); }
.ei-tbtn.on-teal    { background:linear-gradient(135deg,var(--t),var(--t2));color:#fff;box-shadow:0 3px 12px rgba(10,85,86,0.28); }
.ei-tbtn.on-success { background:linear-gradient(135deg,var(--success),#34d399);color:#fff;box-shadow:0 3px 12px rgba(16,185,129,0.28); }
.ei-tbtn.on-warn    { background:linear-gradient(135deg,var(--warn),#fbbf24);color:#fff;box-shadow:0 3px 12px rgba(245,158,11,0.28); }

/* chip */
.ei-chip { display:flex;align-items:center;gap:9px;background:rgba(10,85,86,0.06);border:1.5px solid rgba(10,85,86,0.13);border-radius:10px;padding:9px 14px; }
.ei-chip-num { font-family:'Sora',sans-serif;font-size:13.5px;font-weight:800;color:var(--t); }
.ei-chip-sub { font-size:10px;color:var(--muted);margin-top:1px; }
.ei-divider { height:1px;background:var(--border);margin:18px 0; }

/* billing */
.ei-billing { display:grid;grid-template-columns:1fr 1fr;gap:0; }
.ei-bc { padding:0; }
.ei-bc:first-child { border-right:1px solid var(--border);padding-right:24px; }
.ei-bc:last-child  { padding-left:24px; }
.ei-bchd { display:flex;align-items:center;gap:8px;margin-bottom:14px; }
.ei-bchd-icon { width:28px;height:28px;border-radius:8px;background:rgba(10,85,86,0.08);display:flex;align-items:center;justify-content:center;color:var(--t);font-size:13px; }
.ei-bchd-title { font-family:'Sora',sans-serif;font-size:12.5px;font-weight:700;color:var(--t); }
.ei-bchd-sub   { font-size:10.5px;color:var(--muted); }

/* grids */
.g2 { display:grid;grid-template-columns:1fr 1fr;gap:12px; }
.g3 { display:grid;grid-template-columns:1fr 1fr 1fr;gap:12px; }
.g4 { display:grid;grid-template-columns:1fr 1fr 1fr 1fr;gap:12px; }

/* table */
.ei-tw { overflow-x:auto; }
.ei-table { width:100%;border-collapse:collapse;font-family:'DM Sans',sans-serif; }
.ei-table thead tr { background:linear-gradient(135deg,rgba(10,85,86,0.05),rgba(20,184,166,0.02));border-bottom:2px solid rgba(10,85,86,0.1); }
.ei-table thead th { padding:11px 14px;font-family:'Sora',sans-serif;font-size:10px;font-weight:700;color:var(--t);letter-spacing:.07em;text-transform:uppercase;white-space:nowrap; }
.ei-table tbody tr { border-bottom:1px solid rgba(10,85,86,0.055);transition:background .15s; }
.ei-table tbody tr:last-child { border-bottom:none; }
.ei-table tbody tr:hover { background:rgba(10,85,86,0.025); }
.ei-table td { padding:10px 14px;vertical-align:middle; }
.ei-amt { font-family:'Sora',sans-serif;font-weight:700;font-size:13px;color:var(--t); }
.ei-del { width:30px;height:30px;border-radius:8px;border:1.5px solid rgba(239,68,68,0.22);background:rgba(239,68,68,0.06);color:var(--danger);display:flex;align-items:center;justify-content:center;cursor:pointer;transition:all .18s;font-size:14px; }
.ei-del:hover { background:rgba(239,68,68,0.14);border-color:rgba(239,68,68,0.4);transform:scale(1.08); }
.ei-add-item { display:inline-flex;align-items:center;gap:7px;padding:9px 20px;border-radius:var(--r-sm);border:none;background:linear-gradient(135deg,var(--t),var(--t3));color:#fff;font-family:'Sora',sans-serif;font-size:12.5px;font-weight:700;cursor:pointer;box-shadow:0 5px 16px rgba(10,85,86,0.28);transition:all .2s; }
.ei-add-item:hover { transform:translateY(-2px);box-shadow:0 10px 26px rgba(10,85,86,0.36); }

/* summary */
.ei-sum-layout { display:grid;grid-template-columns:1fr 340px;gap:20px;align-items:start; }
.ei-sum-inner { background:linear-gradient(135deg,rgba(10,85,86,0.04),rgba(20,184,166,0.025));border:1.5px solid rgba(10,85,86,0.11);border-radius:14px;padding:18px 20px; }
.ei-sum-row { display:flex;align-items:center;justify-content:space-between;padding:7px 0;font-size:13px;color:#2f4a4a;border-bottom:1px solid rgba(10,85,86,0.065); }
.ei-sum-row:last-child { border-bottom:none; }
.ei-sum-val { font-family:'Sora',sans-serif;font-weight:700;font-size:13.5px;color:var(--t); }
.ei-sum-red { color:var(--danger); }
.ei-tax-hd  { font-family:'Sora',sans-serif;font-size:11px;font-weight:700;color:var(--muted);text-transform:uppercase;letter-spacing:.06em;margin:14px 0 8px; }
.ei-tax-row { display:flex;align-items:center;justify-content:space-between;font-size:12.5px;padding:5px 0; }
.ei-tax-lbl { color:#3d6060; }
.ei-tax-val { font-family:'Sora',sans-serif;font-weight:700;color:var(--t); }
.ei-gst-pill { display:inline-flex;align-items:center;gap:5px;padding:3px 10px;border-radius:50px;font-size:10.5px;font-weight:700;font-family:'Sora',sans-serif;background:rgba(10,85,86,0.08);color:var(--t);border:1px solid rgba(10,85,86,0.14); }
.ei-grand { background:linear-gradient(135deg,var(--t),var(--t2));border-radius:14px;padding:18px 20px;display:flex;align-items:center;justify-content:space-between;margin-top:16px; }
.ei-grand-lbl { font-family:'Sora',sans-serif;font-size:14px;font-weight:700;color:rgba(255,255,255,0.85); }
.ei-grand-val { font-family:'Sora',sans-serif;font-size:24px;font-weight:800;color:#fff;letter-spacing:-.04em; }

/* save */
.ei-save { width:100%;padding:14px;border:none;border-radius:14px;background:linear-gradient(135deg,var(--t) 0%,var(--t2) 45%,var(--t3) 100%);background-size:200% auto;color:#fff;font-family:'Sora',sans-serif;font-size:14px;font-weight:700;cursor:pointer;box-shadow:0 8px 28px rgba(10,85,86,0.36);transition:all .3s;display:flex;align-items:center;justify-content:center;gap:9px;margin-top:14px; }
.ei-save:hover { background-position:right center;transform:translateY(-2px);box-shadow:0 16px 36px rgba(10,85,86,0.44); }

/* skeleton */
.ei-sk-page { padding:24px;animation:ei-in 0.4s ease; }
.ei-sk-hd   { display:flex;align-items:center;gap:14px;margin-bottom:24px; }
.ei-sk-card { background:rgba(255,255,255,0.9);border-radius:var(--r);padding:22px 24px;margin-bottom:20px;box-shadow:var(--sh); }
.ei-sk-row  { display:flex;gap:14px;margin-bottom:14px; }

/* ── PRODUCT CATALOG TOGGLE BAR ── */
.ei-product-toggle-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 18px;
  background: linear-gradient(135deg, rgba(10,85,86,.05), rgba(20,184,166,.03));
  border-bottom: 1px solid rgba(10,85,86,0.10);
}
.ei-product-toggle-left {
  display: flex;
  align-items: center;
  gap: 9px;
}
.ei-product-toggle-label {
  font-family: 'Sora', sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: var(--t);
  letter-spacing: .03em;
}
.ei-product-toggle-sub {
  font-size: 10.5px;
  color: var(--muted);
  margin-top: 1px;
}
/* iOS pill switch */
.ei-pill-switch {
  position: relative;
  width: 40px;
  height: 22px;
  flex-shrink: 0;
}
.ei-pill-switch input { opacity:0; width:0; height:0; position:absolute; }
.ei-pill-slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background: #c8e4e4;
  border-radius: 50px;
  transition: background .25s;
}
.ei-pill-slider::before {
  content: '';
  position: absolute;
  height: 16px; width: 16px;
  left: 3px; top: 3px;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 1px 4px rgba(0,0,0,.18);
  transition: transform .25s;
}
.ei-pill-switch input:checked + .ei-pill-slider { background: linear-gradient(135deg, var(--t), var(--t3)); }
.ei-pill-switch input:checked + .ei-pill-slider::before { transform: translateX(18px); }

/* react-select overrides */
.ei-rs__control {
  background: rgba(10,85,86,0.035) !important;
  border: 1.5px solid rgba(10,85,86,0.13) !important;
  border-radius: var(--r-sm) !important;
  min-height: 34px !important;
  box-shadow: none !important;
  font-family: 'DM Sans', sans-serif !important;
  font-size: 12.5px !important;
  transition: border-color .2s, box-shadow .2s !important;
}
.ei-rs__control--is-focused {
  border-color: var(--t) !important;
  background: #fff !important;
  box-shadow: 0 0 0 3px rgba(10,85,86,.10) !important;
}
.ei-rs__placeholder { color: #9abcbc !important; font-size: 12.5px !important; }
.ei-rs__single-value { color: var(--text) !important; font-size: 12.5px !important; }
.ei-rs__input-container { color: var(--text) !important; font-size: 12.5px !important; }
.ei-rs__menu {
  border-radius: 12px !important;
  border: 1.5px solid rgba(10,85,86,0.13) !important;
  box-shadow: 0 8px 28px rgba(10,85,86,.14) !important;
  overflow: hidden !important;
  font-family: 'DM Sans', sans-serif !important;
  z-index: 9999 !important;
}
.ei-rs__option {
  font-size: 12.5px !important;
  padding: 9px 14px !important;
  cursor: pointer !important;
}
.ei-rs__option--is-focused { background: rgba(10,85,86,.07) !important; color: var(--text) !important; }
.ei-rs__option--is-selected { background: linear-gradient(135deg, var(--t), var(--t3)) !important; color: #fff !important; }
.ei-rs__indicator-separator { background-color: rgba(10,85,86,0.13) !important; }
.ei-rs__dropdown-indicator { color: var(--t) !important; padding: 0 8px !important; }
.ei-rs__clear-indicator { color: var(--muted) !important; }
.ei-rs__value-container { padding: 2px 10px !important; }

/* product option renderer */
.ei-opt__badge {
  display: inline-block;
  padding: 1px 7px;
  border-radius: 50px;
  font-size: 9.5px;
  font-weight: 700;
  font-family: 'Sora', sans-serif;
  margin-left: 6px;
  vertical-align: middle;
}
.ei-opt__badge--service { background: rgba(20,184,166,.15); color: #0c7172; }
.ei-opt__badge--product { background: rgba(255,209,102,.22); color: #8a6000; }
.ei-opt__meta { font-size: 10.5px; color: var(--muted); margin-top: 1px; }
.ei-opt__row { display: flex; align-items: center; justify-content: space-between; }
.ei-opt__rate { font-family: 'Sora', sans-serif; font-weight: 700; font-size: 11px; color: var(--t); }

/* responsive */
@media (max-width:960px) {
  .ei-billing { grid-template-columns:1fr; }
  .ei-bc:first-child { border-right:none;border-bottom:1px solid var(--border);padding-right:0;padding-bottom:18px;margin-bottom:18px; }
  .ei-bc:last-child { padding-left:0; }
  .g3 { grid-template-columns:1fr 1fr; }
  .g4 { grid-template-columns:1fr 1fr; }
  .ei-sum-layout { grid-template-columns:1fr; }
  .ei-wrap { padding:14px 14px 52px; }
}
@media (max-width:600px) {
  .g2 { grid-template-columns:1fr; }
  .g4 { grid-template-columns:1fr 1fr; }
}
`;

/* ─────────────────── CONSTANTS ─────────────────── */
const GST_SLABS = [0, 5, 12, 18, 28];
const splitGST = (totalTax, gstType) => {
    if (gstType === "IGST") return { IGST: totalTax, CGST: 0, SGST: 0 };
    return { IGST: 0, CGST: totalTax / 2, SGST: totalTax / 2 };
};

/* ── Custom Option renderer for React Select ── */
const ProductOption = ({ innerRef, innerProps, data, isSelected }) => (
    <div
        ref={innerRef}
        {...innerProps}
        style={{
            padding: "9px 14px",
            cursor: "pointer",
            background: isSelected
                ? "linear-gradient(135deg, #0a5556, #14b8a6)"
                : "transparent",
            color: isSelected ? "#fff" : "#07282a",
        }}
    >
        <div className="ei-opt__row">
            <span style={{ fontWeight: 600, fontSize: 12.5 }}>
                {data.label}
                <span
                    className={`ei-opt__badge ${data.type === "Service" ? "ei-opt__badge--service" : "ei-opt__badge--product"}`}
                    style={isSelected ? { background: "rgba(255,255,255,.22)", color: "#fff" } : {}}
                >
                    {data.type}
                </span>
            </span>
            <span className="ei-opt__rate" style={isSelected ? { color: "rgba(255,255,255,.85)" } : {}}>
                ₹{data.rate}
            </span>
        </div>
        <div className="ei-opt__meta" style={isSelected ? { color: "rgba(255,255,255,.65)" } : {}}>
            HSN/SAC: {data.hsn || "—"} · GST {data.tax}%
        </div>
    </div>
);

/* ─────────────────── COMPONENT ─────────────────── */
function EditInvoice() {

    const getDefaultDate = (daysOffset = 0) => {
        const date = new Date();
        date.setDate(date.getDate() + daysOffset);
        const istOffset = 5.5 * 60 * 60 * 1000;
        const istDate = new Date(date.getTime() + istOffset);
        return istDate.toISOString().split("T")[0];
    };

    const token = localStorage.getItem("auth_token");

    const [customerLookupLoading, setCustomerLookupLoading] = useState(false);
    const [foundCustomer, setFoundCustomer]   = useState(null);
    const [showCustomerModal, setShowCustomerModal] = useState(false);
    const [applyGSTItemWise, setApplyGSTItemWise]   = useState(true);
    const [invoiceGSTPercent, setInvoiceGSTPercent] = useState(18);
    const [loading, setLoading] = useState(false);

    // ── Product Catalog State ──
    const [productOptions, setProductOptions] = useState([]);
    const [useProductDropdown, setUseProductDropdown] = useState(false);

    const [invoice, setInvoice] = useState({
        invoiceNumber: "",
        invoiceDate: getDefaultDate(0),
        dueDate: getDefaultDate(15),
        paymentStatus: "",
        customer: { name: "", email: "", phone: "", address: "", gstin: "", state: "" },
        seller:   { name: "", gstin: "", state: "", phone: "" },
        items: [],
        discount: 0,
        additionalCharges: 0,
        gstInclusive: false,
        notes: "",
    });

    const { id } = useParams();
    let invoiceId;
    try {
        invoiceId = atob(id);
        console.log("Decoded Invoice ID:", invoiceId);
    } catch (err) {
        console.error("Invalid invoice ID");
    }

    // ── Fetch Invoice ──
    useEffect(() => {
        const fetchInvoice = async () => {
            if (!invoiceId) return;
            setLoading(true);
            try {
                const res = await axios.get(`${baseurl}getInvoiceById/${invoiceId}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                if (res.data.success && res.data.data && res.data.data.invoice_data) {
                    const inv = res.data.data.invoice_data;
                    const invoiceNumber = res.data.data.invoice_number;
                    setInvoice({
                        invoiceNumber: invoiceNumber || "",
                        invoiceDate:   inv.invoiceDate   || getDefaultDate(0),
                        dueDate:       inv.dueDate       || getDefaultDate(15),
                        paymentStatus: inv.paymentStatus || "",
                        customer: inv.customer || { name:"",email:"",phone:"",address:"",gstin:"",state:"" },
                        seller:   inv.seller   || { name:"",gstin:"",state:"",phone:"" },
                        items:    inv.items    || [],
                        discount: Number(inv.discount || 0),
                        additionalCharges: Number(inv.additionalCharges || 0),
                        gstInclusive: inv.gstInclusive || false,
                        notes: inv.notes || "",
                    });
                }
            } catch (err) {
                console.error(err);
                Swal.fire("Error", "Could not load invoice data", "error");
            } finally { setLoading(false); }
        };
        if (invoiceId) fetchInvoice();
    }, [invoiceId, token]);

    // ── Fetch Product Catalog ──
    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const res = await axios.get(`${baseurl}getAllProducts`, {
                    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
                });
                if (res.data.success && res.data.data) {
                    const options = res.data.data.map((p) => ({
                        value: p.id,
                        label: p.product_data?.name || `Product #${p.id}`,
                        description: p.product_data?.name || "",
                        hsn: p.product_data?.hsn_sac || "",
                        rate: p.product_data?.rate ?? 0,
                        tax: p.product_data?.tax_percent ?? 18,
                        type: p.type || "Product",
                        unit: p.product_data?.unit || "",
                    }));
                    setProductOptions(options);
                }
            } catch (err) {
                console.error("Error fetching products:", err);
            }
        };
        fetchProducts();
    }, []);

    const updateInvoiceMeta = (fieldName, value) =>
        setInvoice(prev => ({ ...prev, [fieldName]: value }));

    const handlePaymentStatusChange = (status) => {
        setInvoice(prev => {
            const newState = { ...prev, paymentStatus: status };
            if (prev.paymentStatus === 'Paid' && status === 'Due') {
                newState.dueDate = getDefaultDate(15);
            }
            return newState;
        });
    };

    const isPaid = invoice.paymentStatus === 'Paid';

    useEffect(() => {
        const $invoiceDate = $('#invoiceDateInput');
        const $dueDate     = $('#dueDateInput');
        const handleDateSelect = (dateText, inst) => {
            const fieldName = inst.id === 'invoiceDateInput' ? 'invoiceDate' : 'dueDate';
            updateInvoiceMeta(fieldName, dateText);
        };
        $invoiceDate.datepicker({ dateFormat:"yy-mm-dd", onSelect:handleDateSelect, defaultDate:invoice.invoiceDate });
        $dueDate.datepicker({     dateFormat:"yy-mm-dd", onSelect:handleDateSelect, defaultDate:invoice.dueDate });
        return () => { $invoiceDate.datepicker('destroy'); $dueDate.datepicker('destroy'); };
    }, []);

    useEffect(() => {
        $('#invoiceDateInput').datepicker('setDate', invoice.invoiceDate);
        if (!isPaid) $('#dueDateInput').datepicker('setDate', invoice.dueDate);
    }, [invoice.invoiceDate, invoice.dueDate, isPaid]);

    useEffect(() => {
        const $invoiceDate = $('#invoiceDateInput');
        const $dueDate     = $('#dueDateInput');
        $invoiceDate.datepicker({ dateFormat:"yy-mm-dd", defaultDate:invoice.invoiceDate, showOn:"focus", onSelect:(dateText) => updateInvoiceMeta('invoiceDate', dateText) });
        if (!isPaid) {
            $dueDate.datepicker({ dateFormat:"yy-mm-dd", defaultDate:invoice.dueDate, showOn:"focus", onSelect:(dateText) => updateInvoiceMeta('dueDate', dateText) });
        }
        return () => { $invoiceDate.datepicker('destroy'); $dueDate.datepicker('destroy'); };
    }, [isPaid]);

    useEffect(() => {
        $('#invoiceDateInput').datepicker('setDate', invoice.invoiceDate);
        if (!isPaid) $('#dueDateInput').datepicker('setDate', invoice.dueDate);
    }, [invoice.invoiceDate, invoice.dueDate, isPaid]);

    const addItem = () =>
        setInvoice(prev => ({ ...prev, items:[...prev.items,{description:"",hsn:"",qty:1,rate:0,tax:0}] }));
    const removeItem = (index) =>
        setInvoice(prev => ({ ...prev, items:prev.items.filter((_,i)=>i!==index) }));
    const updateItem = (index, field, value) => {
        const items = [...invoice.items];
        items[index][field] = value;
        setInvoice({ ...invoice, items });
    };
    const updateCustomer = (field, value) =>
        setInvoice(prev => ({ ...prev, customer:{...prev.customer,[field]:value} }));
    const updateSeller = (field, value) =>
        setInvoice(prev => ({ ...prev, seller:{...prev.seller,[field]:value} }));

    // ── Handle product selection from dropdown ──
const handleProductSelect = (index, selectedOption) => {
  const items = [...invoice.items];
  if (!selectedOption) {
    items[index] = { ...items[index], description: "", hsn: "", rate: 0, tax: 18 };
  } else {
    items[index] = {
      ...items[index],
      description: selectedOption.description,
      hsn: selectedOption.hsn,
      rate: selectedOption.rate,
      tax: selectedOption.tax,
      // qty intentionally preserved
    };
  }
  setInvoice({ ...invoice, items });
};

    // Find matching option for a row
    const getSelectedProductOption = (item) => {
        if (!item.description) return null;
        return productOptions.find(
            (o) => o.description === item.description && o.rate === item.rate
        ) || null;
    };

    const { items=[], discount=0, additionalCharges=0, gstInclusive=false, customer={}, seller={} } = invoice;
    const itemSubtotal   = items.reduce((acc,item)=>acc+(Number(item.qty)||0)*(Number(item.rate)||0),0);
    const subtotal       = itemSubtotal;
    const discountAmount = (subtotal*(Number(discount)||0))/100;
    const taxableAmount  = subtotal - discountAmount + (Number(additionalCharges)||0);

    const calculateTotalTax = () => {
        const taxRateToUse = applyGSTItemWise ? 0 : Number(invoiceGSTPercent||0);
        if (applyGSTItemWise) {
            return items.reduce((acc,item)=>{
                const itemAmount=(Number(item.qty)||0)*(Number(item.rate)||0);
                const taxRate=Number(item.tax||0);
                return gstInclusive ? acc+(itemAmount*taxRate)/(100+taxRate) : acc+(itemAmount*taxRate)/100;
            },0);
        } else {
            return gstInclusive ? (taxableAmount*taxRateToUse)/(100+taxRateToUse) : (taxableAmount*taxRateToUse)/100;
        }
    };

    const totalTax     = calculateTotalTax();
    
    const isInterState =
  !!(customer?.state?.trim()) &&
  !!(seller?.state?.trim()) &&
  customer.state.trim().toLowerCase() !== seller.state.trim().toLowerCase();
  
  const gstType      = isInterState ? "IGST" : "CGST_SGST";
    const { IGST, CGST, SGST } = splitGST(totalTax, gstType);
    const grandTotal   = gstInclusive ? taxableAmount : taxableAmount + totalTax;

    const getItemAmountDisplay = (item, isItemWise) => {
        const qty=Number(item.qty)||0, rate=Number(item.rate)||0, tax=Number(item.tax||0);
        const grossAmount=qty*rate;
        if (gstInclusive) return grossAmount.toFixed(2);
        return (grossAmount+(grossAmount*(isItemWise?tax:invoiceGSTPercent))/100).toFixed(2);
    };

    const fmt = (n) =>
        Number(n).toLocaleString("en-IN",{style:"currency",currency:"INR",minimumFractionDigits:2});

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!token) { Swal.fire("Unauthorized","Please login again","error"); return; }
        const { items=[], discount=0, additionalCharges=0, gstInclusive=false } = invoice;
        const itemSubtotal = items.reduce((acc,item)=>acc+(Number(item.qty)||0)*(Number(item.rate)||0),0);
        const subtotal     = itemSubtotal;
        const discountAmount = (subtotal*(Number(discount)||0))/100;
        const taxableAmount  = subtotal - discountAmount + (Number(additionalCharges)||0);
        const calculateTotalTax = () => {
            const taxRateToUse = applyGSTItemWise ? 0 : Number(invoiceGSTPercent||0);
            if (applyGSTItemWise) {
                return items.reduce((acc,item)=>{
                    const itemAmount=(Number(item.qty)||0)*(Number(item.rate)||0);
                    const taxRate=Number(item.tax||0);
                    return gstInclusive ? acc+(itemAmount*taxRate)/(100+taxRate) : acc+(itemAmount*taxRate)/100;
                },0);
            } else {
                return gstInclusive ? (taxableAmount*taxRateToUse)/(100+taxRateToUse) : (taxableAmount*taxRateToUse)/100;
            }
        };
        const totalTax     = calculateTotalTax();
        // const isInterState = (invoice.customer?.state?.trim()?.toLowerCase()||"") !== (invoice.seller?.state?.trim()?.toLowerCase()||"");
        
const isInterState =
  !!(customer?.state?.trim()) &&
  !!(seller?.state?.trim()) &&
  customer.state.trim().toLowerCase() !== seller.state.trim().toLowerCase(); 


  const gstType      = isInterState ? "IGST" : "CGST_SGST";
        const { IGST, CGST, SGST } = splitGST(totalTax, gstType);
        const grandTotal   = gstInclusive ? taxableAmount : taxableAmount + totalTax;
        const payload = {
            id: invoiceId,
            invoiceNumber: invoice.invoiceNumber,
            invoiceDate:   invoice.invoiceDate,
            dueDate:       invoice.dueDate,
            paymentStatus: invoice.paymentStatus,
            customer:      invoice.customer,
            seller:        invoice.seller,
            items:         invoice.items,
            discount:          Number(invoice.discount||0),
            additionalCharges: Number(invoice.additionalCharges||0),
            gstInclusive:  invoice.gstInclusive,
            notes:         invoice.notes,
            itemSubtotal, taxableAmount, totalTax, grandTotal,
            gstBreakdown: { IGST, CGST, SGST, gstType, isInterState },
        };
        console.log("payload", payload);
        try {
            const res = await axios.post(
                `${baseurl}updateGstInvoice`,
                payload,
                { headers: { Authorization:`Bearer ${token}`, "Content-Type":"application/json" } }
            );
            if (res.data.success) {
                Swal.fire({ toast:true, position:"top-end", icon:"success", title:"Invoice updated successfully", showConfirmButton:false, timer:2500 });
                setTimeout(() => { window.location.href="/invoices"; }, 1200);
            } else {
                Swal.fire("Error", res.data.message||"Failed to update invoice", "error");
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error", error.response?.data?.message||"Failed to update invoice", "error");
        }
    };

    /* ── Skeleton ── */
    if (loading) {
        return (
            <>
                <style>{CSS}</style>
                <Topbar /><Sidebar />
                <main className="main-wrapper">
                    <div className="ei-page">
                        <div className="ei-blob ei-blob-1"/><div className="ei-blob ei-blob-2"/><div className="ei-blob ei-blob-3"/><div className="ei-grid"/>
                        <div className="ei-sk-page">
                            <div className="ei-sk-hd">
                                <Skeleton width={50} height={50} borderRadius={16}/>
                                <div><Skeleton width={240} height={24}/><Skeleton width={180} height={13} style={{marginTop:6}}/></div>
                            </div>
                            <div className="ei-sk-card">
                                <div className="ei-sk-row">{[1,2,3,4].map(i=><Skeleton key={i} width="23%" height={44} borderRadius={10}/>)}</div>
                                <Skeleton width={160} height={15} style={{margin:"16px 0 10px"}}/>
                                <div className="ei-sk-row">{[1,2,3].map(i=><Skeleton key={i} width="32%" height={40} borderRadius={10}/>)}</div>
                            </div>
                            <div className="ei-sk-card">
                                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:24}}>
                                    <div>{[1,2,3,4].map(i=><Skeleton key={i} height={36} borderRadius={10} style={{marginBottom:12}}/>)}</div>
                                    <div>{[1,2,3,4,5].map(i=><Skeleton key={i} height={36} borderRadius={10} style={{marginBottom:12}}/>)}</div>
                                </div>
                            </div>
                            <div className="ei-sk-card">
                                <Skeleton width="28%" height={20} style={{marginBottom:16}}/>
                                {[1,2,3].map(i=>(
                                    <div key={i} className="ei-sk-row">
                                        <Skeleton width="34%" height={34} borderRadius={9}/>
                                        <Skeleton width="10%" height={34} borderRadius={9}/>
                                        <Skeleton width="8%"  height={34} borderRadius={9}/>
                                        <Skeleton width="12%" height={34} borderRadius={9}/>
                                    </div>
                                ))}
                            </div>
                            <div style={{display:"grid",gridTemplateColumns:"1fr 340px",gap:20}}>
                                <Skeleton height={200} borderRadius={18}/><Skeleton height={280} borderRadius={18}/>
                            </div>
                        </div>
                    </div>
                </main>
            </>
        );
    }

    if (!invoice) return null;

    /* ─────────────── RENDER ─────────────── */
    return (
        <>
            <style>{CSS}</style>
            <Topbar />
            <Sidebar />
            <main className="main-wrapper">
                <div className="ei-page">
                    <div className="ei-blob ei-blob-1"/>
                    <div className="ei-blob ei-blob-2"/>
                    <div className="ei-blob ei-blob-3"/>
                    <div className="ei-grid"/>

                    <div className="ei-wrap">
                        <form onSubmit={handleSubmit}>

                            {/* Page Header */}
                            <div className="ei-hd">
                                <div className="ei-hd-left">
                                    <div className="ei-hd-icon"><FiEdit3/></div>
                                    <div>
                                        <h2 className="ei-title">Edit GST Invoice</h2>
                                        <p className="ei-sub">Update invoice details, items &amp; billing information</p>
                                    </div>
                                </div>
                                <div className="ei-badge">
                                    <FiZap size={11}/> Editing: {invoice.invoiceNumber || "—"}
                                </div>
                            </div>

                            {/* ── SECTION 1: Invoice Details ── */}
                            <div className="ei-sec">
                                <div className="ei-sec-dot"><FiFileText size={13}/></div>
                                <span className="ei-sec-lbl">Invoice Details</span>
                            </div>
                            <div className="ei-card">
                                <div className="ei-cb">
                                    <div className="g4" style={{alignItems:"end"}}>
                                        <div>
                                            <label className="ei-label">Invoice Number</label>
                                            <div className="ei-chip">
                                                <FiTag size={13} style={{color:"var(--t)",flexShrink:0}}/>
                                                <div>
                                                    <div className="ei-chip-num">{invoice.invoiceNumber || "—"}</div>
                                                    <div className="ei-chip-sub">Read only</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <label className="ei-label">Invoice Date</label>
                                            <input id="invoiceDateInput" type="text" className="ei-input" value={invoice.invoiceDate} readOnly/>
                                        </div>
                                        <div>
                                            <label className="ei-label">Payment Status</label>
                                            <div className="ei-toggle">
                                                <button type="button" className={`ei-tbtn ${!isPaid?"on-warn":""}`} onClick={()=>handlePaymentStatusChange("Due")}>
                                                    <FiClock size={12}/> Due
                                                </button>
                                                <button type="button" className={`ei-tbtn ${isPaid?"on-success":""}`} onClick={()=>handlePaymentStatusChange("Paid")}>
                                                    <FiCheckCircle size={12}/> Paid
                                                </button>
                                            </div>
                                        </div>
                                        <div>
                                            <label className="ei-label">Due Date</label>
                                            <input id="dueDateInput" type="text" className="ei-input"
                                                value={isPaid?"N/A (Paid)":invoice.dueDate}
                                                readOnly={isPaid} disabled={isPaid}
                                                style={isPaid?{color:"var(--success)",fontWeight:700}:{}}
                                            />
                                        </div>
                                    </div>

                                    <div className="ei-divider"/>

                                    <div className="ei-sec" style={{marginBottom:12}}>
                                        <div className="ei-sec-dot" style={{width:26,height:26,borderRadius:8,fontSize:11}}><FiSettings size={11}/></div>
                                        <span className="ei-sec-lbl" style={{fontSize:12}}>GST &amp; Tax Settings</span>
                                    </div>
                                    <div className="g3">
                                        <div>
                                            <label className="ei-label">GST Mode</label>
                                            <div className="ei-toggle">
                                                <button type="button" className={`ei-tbtn ${!invoice.gstInclusive?"on-teal":""}`} onClick={()=>setInvoice({...invoice,gstInclusive:false})}>Exclusive</button>
                                                <button type="button" className={`ei-tbtn ${invoice.gstInclusive?"on-teal":""}`}  onClick={()=>setInvoice({...invoice,gstInclusive:true})}>Inclusive</button>
                                            </div>
                                        </div>
                                        <div>
                                            <label className="ei-label">Apply Tax By</label>
                                            <div className="ei-toggle">
                                                <button type="button" className={`ei-tbtn ${applyGSTItemWise?"on-teal":""}`}  onClick={()=>setApplyGSTItemWise(true)}>Item-wise</button>
                                                <button type="button" className={`ei-tbtn ${!applyGSTItemWise?"on-teal":""}`} onClick={()=>setApplyGSTItemWise(false)}>Invoice-wise</button>
                                            </div>
                                        </div>
                                        {!applyGSTItemWise && (
                                            <div>
                                                <label className="ei-label">Invoice GST %</label>
                                                <select className="ei-select" value={invoiceGSTPercent} onChange={e=>setInvoiceGSTPercent(parseFloat(e.target.value))}>
                                                    {GST_SLABS.map(g=><option key={g} value={g}>{g}%</option>)}
                                                </select>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* ── SECTION 2: Billing Details ── */}
                            <div className="ei-sec">
                                <div className="ei-sec-dot"><FiUser size={13}/></div>
                                <span className="ei-sec-lbl">Billing Details</span>
                            </div>
                            <div className="ei-card">
                                <div className="ei-cb">
                                    <div className="ei-billing">
                                        {/* Seller */}
                                        <div className="ei-bc">
                                            <div className="ei-bchd">
                                                <div className="ei-bchd-icon"><FiUser size={13}/></div>
                                                <div>
                                                    <div className="ei-bchd-title">Seller Details</div>
                                                    <div className="ei-bchd-sub">Service / Goods Provider</div>
                                                </div>
                                            </div>
                                            <div className="ei-field">
                                                <label className="ei-label">Business Name</label>
                                                <input type="text" className="ei-input" value={seller.name} onChange={e=>updateSeller("name",e.target.value)}/>
                                            </div>
                                            <div className="ei-field">
                                                <label className="ei-label">Phone Number</label>
                                                <input type="text" className="ei-input" value={seller.phone} onChange={e=>updateSeller("phone",e.target.value)}/>
                                            </div>
                                            <div className="g2">
                                                <div className="ei-field">
                                                    <label className="ei-label">GSTIN <span style={{fontWeight:400,textTransform:"none",fontSize:10}}>(Optional)</span></label>
                                                    <input type="text" className="ei-input" value={seller.gstin} onChange={e=>updateSeller("gstin",e.target.value)}/>
                                                </div>
                                                <div className="ei-field">
                                                    <label className="ei-label">State</label>
                                                    <input type="text" className="ei-input" value={seller.state} onChange={e=>updateSeller("state",e.target.value)}/>
                                                </div>
                                            </div>
                                        </div>
                                        {/* Customer */}
                                        <div className="ei-bc">
                                            <div className="ei-bchd">
                                                <div className="ei-bchd-icon"><FiUser size={13}/></div>
                                                <div>
                                                    <div className="ei-bchd-title">Customer Details</div>
                                                    <div className="ei-bchd-sub">Bill To</div>
                                                </div>
                                            </div>
                                            <div className="ei-field">
                                                <label className="ei-label">Customer Name</label>
                                                <input type="text" className="ei-input" placeholder="Full name" value={customer.name} onChange={e=>updateCustomer("name",e.target.value)}  />
                                            </div>
                                            <div className="ei-field">
                                                <label className="ei-label" style={{display:"flex",alignItems:"center",gap:6}}>
                                                    Phone Number
                                                    <FaInfoCircle title="Enter phone to auto-fetch customer" style={{color:"var(--muted)",cursor:"pointer",fontSize:12}}/>
                                                    {customerLookupLoading && <span style={{fontWeight:400,textTransform:"none",fontSize:10,color:"var(--t)",fontStyle:"italic"}}>Searching…</span>}
                                                </label>
                                                <input type="text" className="ei-input" placeholder="10-digit mobile" value={customer.phone} onChange={e=>updateCustomer("phone",e.target.value)}  />
                                            </div>
                                            <div className="g2">
                                                <div className="ei-field">
                                                    <label className="ei-label">GSTIN <span style={{fontWeight:400,textTransform:"none",fontSize:10}}>(Optional)</span></label>
                                                    <input type="text" className="ei-input" placeholder="GSTIN" value={customer.gstin} onChange={e=>updateCustomer("gstin",e.target.value)}/>
                                                </div>
                                                <div className="ei-field">
                                                    <label className="ei-label">State</label>
                                                    <input type="text" className="ei-input" placeholder="State" value={customer.state} onChange={e=>updateCustomer("state",e.target.value)}/>
                                                </div>
                                            </div>
                                            <div className="ei-field">
                                                <label className="ei-label">Address</label>
                                                <textarea className="ei-ta" rows="2" placeholder="Full address" value={customer.address} onChange={e=>updateCustomer("address",e.target.value)}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ── SECTION 3: Items ── */}
                            <div className="ei-sec">
                                <div className="ei-sec-dot"><FiPackage size={13}/></div>
                                <span className="ei-sec-lbl">Invoice Items</span>
                            </div>
                            <div className="ei-card">

                                {/* ── Product/Service Dropdown Toggle Bar ── */}
                                <div className="ei-product-toggle-bar">
                                    <div className="ei-product-toggle-left">
                                        <FiPackage size={14} style={{ color: "var(--t)" }} />
                                        <div>
                                            <div className="ei-product-toggle-label">
                                                Select from Product / Service Catalog
                                            </div>
                                            <div className="ei-product-toggle-sub">
                                                {useProductDropdown
                                                    ? `${productOptions.length} items available — search by name`
                                                    : "Enable to pick items from your saved catalog"}
                                            </div>
                                        </div>
                                    </div>
                                    <label className="ei-pill-switch">
                                        <input
                                            type="checkbox"
                                            checked={useProductDropdown}
                                            onChange={(e) => setUseProductDropdown(e.target.checked)}
                                        />
                                        <span className="ei-pill-slider" />
                                    </label>
                                </div>

                                <div className="ei-tw">
                                    <table className="ei-table">
                                        <thead>
                                            <tr>
                                                {useProductDropdown && <th style={{width:"18%"}}>Product / Service</th>}
                                                <th style={{width: useProductDropdown ? "20%" : "34%"}}>Description</th>
                                                <th style={{width:"10%"}}>HSN/SAC</th>
                                                <th style={{width:"8%"}}>Qty</th>
                                                <th style={{width:"12%"}}>Rate ({gstInclusive?"Inc. Tax":"Excl. Tax"})</th>
                                                {applyGSTItemWise && <th style={{width:"10%"}}>Tax %</th>}
                                                <th style={{width:"13%"}}>Amount</th>
                                                <th style={{width:"6%",textAlign:"center"}}>Del</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {items.map((item, index) => (
                                                <tr key={index}>

                                                    {/* ── Product Dropdown (only when toggle ON) ── */}
                                                    {useProductDropdown && (
                                                        <td style={{ minWidth: 170 }}>
                                                            <Select
                                                                classNamePrefix="ei-rs"
                                                                options={productOptions}
                                                                value={getSelectedProductOption(item)}
                                                                onChange={(opt) => handleProductSelect(index, opt)}
                                                                placeholder="Search…"
                                                                isClearable
                                                                components={{ Option: ProductOption }}
                                                                menuPortalTarget={document.body}
                                                                styles={{
                                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                                    control: (base) => ({ ...base, minHeight: 34 }),
                                                                }}
                                                            />
                                                        </td>
                                                    )}

                                                    <td><input type="text"   className="ei-input ei-input-sm" value={item.description} onChange={e=>updateItem(index,"description",e.target.value)} placeholder="Item description"/></td>
                                                    <td><input type="text"   className="ei-input ei-input-sm" value={item.hsn}         onChange={e=>updateItem(index,"hsn",e.target.value)} placeholder="HSN"/></td>
                                                    <td><input type="number" className="ei-input ei-input-sm" value={item.qty}         onChange={e=>updateItem(index,"qty",parseFloat(e.target.value)||0)}/></td>
                                                    <td><input type="number" className="ei-input ei-input-sm" value={item.rate}        onChange={e=>updateItem(index,"rate",parseFloat(e.target.value)||0)}/></td>
                                                    {applyGSTItemWise && (
                                                        <td>
                                                            <select className="ei-select ei-select-sm" value={item.tax} onChange={e=>updateItem(index,"tax",parseFloat(e.target.value))}>
                                                                {GST_SLABS.map(g=><option key={g} value={g}>{g}%</option>)}
                                                            </select>
                                                        </td>
                                                    )}
                                                    <td><span className="ei-amt">₹{getItemAmountDisplay(item,applyGSTItemWise)}</span></td>
                                                    <td style={{textAlign:"center"}}>
                                                        <button type="button" className="ei-del" onClick={()=>removeItem(index)}><FiTrash2 size={13}/></button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="ei-cf">
                                    <button type="button" className="ei-add-item" onClick={addItem}>
                                        <FiPlus size={14}/> Add Line Item
                                    </button>
                                </div>
                            </div>

                            {/* ── SECTION 4: Summary ── */}
                            <div className="ei-sec">
                                <div className="ei-sec-dot"><FiDollarSign size={13}/></div>
                                <span className="ei-sec-lbl">Invoice Summary</span>
                            </div>
                            <div className="ei-sum-layout">
                                {/* Left */}
                                <div className="ei-card">
                                    <div className="ei-cb">
                                        <div className="g2">
                                            <div className="ei-field">
                                                <label className="ei-label">Discount (%)</label>
                                                <input type="number" className="ei-input" value={discount}
                                                    onChange={e=>setInvoice({...invoice,discount:parseFloat(e.target.value)||0})} min="0" max="100"/>
                                                {discountAmount>0 && <div className="ei-hint" style={{color:"var(--danger)"}}>− {fmt(discountAmount)} deducted</div>}
                                            </div>
                                            <div className="ei-field">
                                                <label className="ei-label">Additional Charges (₹)</label>
                                                <input type="number" className="ei-input" value={additionalCharges}
                                                    onChange={e=>setInvoice({...invoice,additionalCharges:parseFloat(e.target.value)||0})} min="0"/>
                                            </div>
                                        </div>
                                        <div className="ei-field" style={{marginBottom:0}}>
                                            <label className="ei-label">Notes / Terms &amp; Conditions</label>
                                            <textarea className="ei-ta" rows="3" value={invoice.notes}
                                                onChange={e=>setInvoice({...invoice,notes:e.target.value})}
                                                placeholder="Payment terms, bank details, thank you note…"/>
                                        </div>
                                    </div>
                                </div>
                                {/* Right */}
                                <div>
                                    <div className="ei-card" style={{marginBottom:0}}>
                                        <div className="ei-cb">
                                            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:14}}>
                                                <span style={{fontFamily:"'Sora',sans-serif",fontSize:12,fontWeight:700,color:"var(--t)",textTransform:"uppercase",letterSpacing:".06em"}}>Breakdown</span>
                                                <span className="ei-gst-pill">{gstType==="IGST"?"Inter-State · IGST":"Intra-State · CGST+SGST"}</span>
                                            </div>
                                            <div className="ei-sum-inner">
                                                <div className="ei-sum-row">
                                                    <span>Subtotal</span>
                                                    <span className="ei-sum-val">{fmt(itemSubtotal)}</span>
                                                </div>
                                                {discountAmount>0 && (
                                                    <div className="ei-sum-row">
                                                        <span>Discount ({discount}%)</span>
                                                        <span className="ei-sum-val ei-sum-red">− {fmt(discountAmount)}</span>
                                                    </div>
                                                )}
                                                {Number(additionalCharges)>0 && (
                                                    <div className="ei-sum-row">
                                                        <span>Additional Charges</span>
                                                        <span className="ei-sum-val">+ {fmt(additionalCharges)}</span>
                                                    </div>
                                                )}
                                                <div className="ei-sum-row">
                                                    <span>Taxable Base</span>
                                                    <span className="ei-sum-val">{fmt(taxableAmount)}</span>
                                                </div>
                                            </div>
                                            <div className="ei-tax-hd">Tax Breakdown</div>
                                            {gstType==="IGST" ? (
                                                <div className="ei-tax-row">
                                                    <span className="ei-tax-lbl">IGST ({applyGSTItemWise?"Variable":`${invoiceGSTPercent}%`})</span>
                                                    <span className="ei-tax-val">{fmt(IGST)}</span>
                                                </div>
                                            ) : (
                                                <>
                                                    <div className="ei-tax-row">
                                                        <span className="ei-tax-lbl">CGST ({applyGSTItemWise ? "Item-wise ÷2" : `${invoiceGSTPercent/2}%`})</span>
                                                        <span className="ei-tax-val">{fmt(CGST)}</span>
                                                    </div>
                                                    <div className="ei-tax-row">
                                                        <span className="ei-tax-lbl">SGST ({applyGSTItemWise ? "Item-wise ÷2" : `${invoiceGSTPercent/2}%`})</span>
                                                        <span className="ei-tax-val">{fmt(SGST)}</span>
                                                    </div>
                                                </>
                                            )}
                                            <div className="ei-tax-row" style={{borderTop:"1.5px solid rgba(10,85,86,0.12)",marginTop:6,paddingTop:8}}>
                                                <span className="ei-tax-lbl" style={{fontWeight:700}}>Total Tax</span>
                                                <span className="ei-tax-val">{fmt(totalTax)}</span>
                                            </div>
                                            <div className="ei-grand">
                                                <span className="ei-grand-lbl">Grand Total</span>
                                                <span className="ei-grand-val">{fmt(grandTotal)}</span>
                                            </div>
                                            <button type="submit" className="ei-save">
                                                <FiSave size={16}/> Update Invoice
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div style={{height:40}}/>
                        </form>
                    </div>
                </div>
            </main>
        </>
    );
}

export default EditInvoice;
